import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetSwipeOldPaymentPlansAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const SwipeOldPaymentPlans = createAsyncThunk('get/swipeOldPaymentPlans', GetSwipeOldPaymentPlansAPI);

export const SwipeOldPaymentPlansSlice = createSlice({
	name: 'swipeOldPaymentPlans',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[SwipeOldPaymentPlans.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[SwipeOldPaymentPlans.rejected.toString()]: setAPIError,
		[SwipeOldPaymentPlans.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;
			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[SwipeOldPaymentPlansSlice.name]: ReturnType<typeof SwipeOldPaymentPlansSlice.reducer>;
}

export const swipeOldPaymentPlansSelector = (state: IStates): any => {
	return state[SwipeOldPaymentPlansSlice.name] || {};
};

export const useSwipeOldPaymentPlans = (): any => useSelector(swipeOldPaymentPlansSelector);

export const getSwipeOldPaymentPlans =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(SwipeOldPaymentPlans(params));
		return;
	};

export const resetSwipeOldPaymentPlans =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(SwipeOldPaymentPlansSlice.actions.RESET());
		return;
	};
